import { Component, Input } from "@angular/core";
import { DataSpaceAttributeItemDTO } from "../../../api/sign-up/signup-api.types";
import { format } from "date-fns";

@Component({
  selector: "mh-data-space-attribute-view",
  templateUrl: "./data-space-attribute-view.component.html",
  styleUrls: ["./data-space-attribute-view.component.less"],
})
export class DataSpaceAttributeViewComponent {
  @Input() attr!: DataSpaceAttributeItemDTO;

  get attrValue() {
    if (!this.attr) return "";
    return this.getAttrValue(this.attr);
  }

  get attrName() {
    if (!this.attr) return "";
    return this.attr.name;
  }

  private getAttrValue(attr: DataSpaceAttributeItemDTO) {
    if (attr.name.includes("TIMESTAMP")) {
      return format(new Date(parseInt(attr.value)), "dd.MM.yyyy HH:mm");
    }
    return attr.value;
  }
}
